import { createContext, useContext } from "react";

const AuthDataContext = createContext(undefined);

/**
 *
 * Provides authentication related information.
 *
 * Data should not change during lifetime.
 *
 */
const AuthDataProvider = ({ children, init }) => {
  // console.log("AuthDataProvider: ", init);
  return <AuthDataContext.Provider value={init}>{children}</AuthDataContext.Provider>;
};

function useAuthData() {
  const context = useContext(AuthDataContext);
  if (context === undefined) {
    throw new Error("useAuthData must be used within a AuthDataProvider");
  }
  return context;
}

export { AuthDataProvider, useAuthData };
